module.exports = __webpack_public_path__ + "static/img/qr-focus.3b867ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qr-focus.png
// module id = OXs3
// module chunks = 3